// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2274":"32742913","3401":"2afb7a50","8744":"46ce30bf"}[chunkId] + ".chunk.css";
};